import { AccommodationContactAttributes, AccommodationContactContact } from '@/types'
import { CreateAccommodationContactMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { contactTypes } from './contact_types'
import { Badge } from '../event_contact_type/badge'
import { useUserContact } from './useUserContact'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  accommodationId: string
  onSuccess: () => void
}

export const Form = ({ accommodationId, onSuccess }: Props) => {
  const {
    attributes,
    setAttributes,
    save,
    saveSuccess,
    formBuilder,
    mutationLoading
  } = useForm<CreateAccommodationContactMutation, AccommodationContactAttributes, never, never>({
    defaultValues: {
      accommodationId,
      name: '',
      email: '',
      phone: '',
      contactType: AccommodationContactContact.FrontOffice,
    },
    mutation: CreateMutation,
    resultKey: 'createAccommodationContact',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  const { pickedUser } = useUserContact({ attributes, setAttributes })

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Person', field: 'userId', type: 'user' }) }
      { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text', disabled: pickedUser }) }
      <div className="grid grid-cols-2 gap-6">
        { formBuilder.buildField({ name: 'Email', field: 'email', type: 'email', disabled: pickedUser }) }
        { formBuilder.buildField({ name: 'Phone', field: 'phone', type: 'text', disabled: pickedUser }) }
      </div>
      { formBuilder.buildField({
        name: 'Contact type',
        field: 'contactType',
        type: 'select',
        options: Object.keys(contactTypes).map(ct => ({
          value: ct,
          display: <Badge eventContact={contactTypes[ct]} />
        }))
      })}
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
